export default "__VITE_ASSET__ed74ffd6__"